import { Helmet } from 'react-helmet-async';
import { SearchTermsAnalysisWithProvider } from 'src/components/visibility';

export default function VisibilitySearchTermsAnalysis() {
  return (
    <>
      <Helmet>
        <title>Search Terms</title>
      </Helmet>

      <SearchTermsAnalysisWithProvider />
    </>
  );
}
